export const ABOVE_POST_LIST = 'above-post-list';
export const ABOVE_HEADER = 'above-header';
export const ABOVE_CONTENT_1 = 'above-content-1';
export const ABOVE_CONTENT_2 = 'above-content-2';
export const BELOW_CONTENT_1 = 'below-content-1';
export const BELOW_CONTENT_2 = 'below-content-2';
export const PAGE_BOTTOM_1 = 'page-bottom-1';
export const PAGE_BOTTOM_2 = 'page-bottom-2';
export const PAGE_BOTTOM_3 = 'page-bottom-3';
